import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { LoginUserContext } from "../provider/LoginUserProvider";

const useWorkoutsFetch = () => {
  const API_URL = process.env.REACT_APP_API_URL;
  const { loading } = useContext(LoginUserContext);
  const workoutsFetch = async () => {
    if (loading) return [];

    // const res = await axios.get(`${API_URL}/api/workouts/`);
    const res = await axios.get(`/api/workouts/`);

    return res.data;
  };
  return { workoutsFetch };
};

export default useWorkoutsFetch;
